import { i18nKey } from '@common/config/localization/constants'

const NO_FEE_OPTIONS = {
  value: 'no-option',
  // i18n key — translated at render in Estimation.tsx.
  label: i18nKey('Nothing available at the moment to cover the fee'),
  paidBy: '',
  token: null,
  speedCoverage: []
}

export { NO_FEE_OPTIONS }
